import React, { useEffect, useState } from 'react';
import { BIDS_DETAILS_URL } from '../../utils/Constant';

export default function PayPalFeeCollection({ bidId, token }) {
  const [job, setJob] = useState(null), [message, setMessage] = useState(''), [busy, setBusy] = useState(false);
  const [orderId, setOrderId] = useState('');
  const url = `${BIDS_DETAILS_URL}/${bidId}/paypal-fee`;
  async function load() {
    const response = await fetch(url, { cache: 'no-store', headers: { Authorization: `Bearer ${token}` } });
    if (!response.ok) throw new Error('Could not check automatic fee status.');
    const data = await response.json(); setJob(data.available ? data.collection : null);
  }
  useEffect(() => { if (bidId && token) load().catch(() => {}); }, [bidId, token]); // eslint-disable-line react-hooks/exhaustive-deps
  async function accept() {
    if (busy) return;
    setBusy(true);
    try {
      const response = await fetch(`${url}/accept`, { method: 'POST', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }, body: '{}' });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Fee collection could not be queued.');
      setMessage(data.message); await load();
    } catch (error) { setMessage(error.message); }
    finally { setBusy(false); }
  }
  async function reconcile() {
    if (busy || !orderId.trim()) return;
    setBusy(true);
    try {
      const response = await fetch(`${url}/reconcile`, { method: 'POST', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }, body: JSON.stringify({ orderId: orderId.trim() }) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error);
      setMessage(data.message); await load();
    } catch (error) { setMessage(error.message); }
    finally { setBusy(false); }
  }
  if (!job) return null;
  return <section className="alert alert-info" aria-label="Automatic PayPal platform fee">
    <h5>Automatic 10% platform fee: ${(job.amountCents / 100).toFixed(2)}</h5>
    <p>{job.environment === 'sandbox' ? 'SANDBOX TEST — no real payment. ' : ''}Status: {job.state.replaceAll('_', ' ')}</p>
    <p>PayPal invoice reference: MTD-FEE-{job._id}</p>
    {job.state === 'awaiting_acceptance' && <button type="button" className="btn btn-primary" disabled={busy} onClick={accept}>Accept win and collect ${(job.amountCents / 100).toFixed(2)} fee</button>}
    {['failed', 'review'].includes(job.state) && <p>The bidder’s further bidding is paused. Check PayPal before retrying or recording payment; no automatic retry will run.</p>}
    {['failed', 'review'].includes(job.state) && <div>
      <label htmlFor="paypal-fee-order">PayPal order ID for this fee</label>
      <input id="paypal-fee-order" value={orderId} onChange={event => setOrderId(event.target.value)} maxLength={30} />
      <button type="button" className="btn btn-secondary" disabled={busy || !orderId.trim()} onClick={reconcile}>Verify existing PayPal payment</button>
    </div>}
    {message && <p role="status">{message}</p>}
  </section>;
}
